export function required(value) {
    if (typeof value === 'function') {
        var validator_1 = value;
        return function (value) {
            return validator_1(value) || required(value);
        };
    }
    else {
        return value == null || value === '' ? 'Required' : '';
    }
}
//# sourceMappingURL=required.js.map